import { AllSelection, NodeSelection, Selection, TextSelection, Transaction, EditorState } from 'prosemirror-state'

import { CellSelection } from 'common/Prose/utils/table/CellSelection'

// NOTE: prosemirror sometimes loses selections when working with marks (e.g.
// adding/removing marks). This happens when the position is a text position
// and it starts before a list item e.g.
// This function can be given a transaction and an editor state with selection and will resolve
// the selection based on its boundaries on the transaction's doc. When no
// positions changed on the doc, this restores the selection.
// an optional offset can be passed to offset the new selection by a certain number of positions.
// This can be useful if the tr modifying operation adds/removes nodes. offset can be a positive or
// negative number
export const preserveSelection = (tr: Transaction, state: EditorState, offset: number = 0) => {
  const oldSelection = state.selection
  let newSelection: Selection | null = null

  if (oldSelection instanceof AllSelection) {
    newSelection = new AllSelection(tr.doc)
  } else if (oldSelection instanceof CellSelection) {
    const $anchorCell = tr.doc.resolve(oldSelection.$anchorCell.pos + offset)
    const $headCell = tr.doc.resolve(oldSelection.$headCell.pos + offset)
    const $includedCells = oldSelection.$includedCells.map(($includedCell) =>
      tr.doc.resolve($includedCell.pos + offset),
    )

    newSelection = new CellSelection($anchorCell, $headCell, $includedCells)
  } else if (oldSelection instanceof NodeSelection) {
    newSelection = NodeSelection.create(tr.doc, oldSelection.from + offset)
  } else if (oldSelection instanceof TextSelection) {
    newSelection = TextSelection.create(tr.doc, oldSelection.anchor + offset, oldSelection.head + offset)
  }

  // Don't update selection if it's unchanged
  if (newSelection && oldSelection.eq(newSelection) && oldSelection.empty) return

  if (state.storedMarks) tr.setStoredMarks(state.storedMarks)
  if (newSelection) tr.setSelection(newSelection)
}
